import { memo } from 'react'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '../../assets/icons/SearchIcon'
import ClearIcon from '../../assets/icons/ClearIcon'

type Props = {
    value: string
    onChange: (value: string) => void
    placeholder: string
    autoFocus?: boolean
}

/**
 * Search input in the standard app style: the theme's small outlined TextField (same as the
 * screener filter search and dialog fields), with a leading search icon and a clear button.
 */
const SupportSearchField = ({ value, onChange, placeholder, autoFocus }: Props) => (
    <TextField
        fullWidth
        size="small"
        autoFocus={autoFocus}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{ 'aria-label': placeholder }}
        InputProps={{
            startAdornment: (
                <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: 'medium', opacity: 0.5 }} />
                </InputAdornment>
            ),
            endAdornment: value ? (
                <InputAdornment position="end">
                    <IconButton size="small" aria-label="Clear search" onClick={() => onChange('')} sx={{ color: 'text.secondary' }}>
                        <ClearIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                </InputAdornment>
            ) : null
        }}
    />
)

export default memo(SupportSearchField)
